export const getResultOptions = (t) => [
    { value: 'gestante', label: t('admin.event.resultGestante') },
    { value: 'vacia', label: t('admin.event.resultVacia') },
    { value: 'dudosa', label: t('admin.event.resultDudosa') },
    { value: 'tratamiento', label: t('admin.event.resultTratamiento') }
]